/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertRfiRequestedFields } from './InternalApiAlertRfiRequestedFields';
import {
    InternalApiAlertRfiRequestedFieldsFromJSON,
    InternalApiAlertRfiRequestedFieldsFromJSONTyped,
    InternalApiAlertRfiRequestedFieldsToJSON,
    InternalApiAlertRfiRequestedFieldsToJSONTyped,
} from './InternalApiAlertRfiRequestedFields';
import type { BridgeApiConversationCounterparty } from './BridgeApiConversationCounterparty';
import {
    BridgeApiConversationCounterpartyFromJSON,
    BridgeApiConversationCounterpartyFromJSONTyped,
    BridgeApiConversationCounterpartyToJSON,
    BridgeApiConversationCounterpartyToJSONTyped,
} from './BridgeApiConversationCounterparty';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * Alert RFI
 * @export
 * @interface InternalApiAlertRfi
 */
export interface InternalApiAlertRfi {
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertRfi
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertRfi
     */
    alertId: number;
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof InternalApiAlertRfi
     */
    alertType: InternalApiAlertType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertRfi
     */
    conversationId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertRfi
     */
    templateId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertRfi
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertRfi
     */
    counterpartyName?: string;
    /**
     * 
     * @type {Array<BridgeApiConversationCounterparty>}
     * @memberof InternalApiAlertRfi
     */
    counterparties: Array<BridgeApiConversationCounterparty>;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiAlertRfi
     */
    createdTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiAlertRfi
     */
    updatedTime?: Date;
    /**
     * Response attributes key value pair
     * @type {{ [key: string]: string; }}
     * @memberof InternalApiAlertRfi
     */
    response?: { [key: string]: string; };
    /**
     * 
     * @type {InternalApiAlertRfiRequestedFields}
     * @memberof InternalApiAlertRfi
     */
    requestedFields?: InternalApiAlertRfiRequestedFields;
    /**
     * 
     * @type {InternalApiAlertRfiStatusEnum}
     * @memberof InternalApiAlertRfi
     */
    status: InternalApiAlertRfiStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiAlertRfi
     */
    isReScreeningEnabled: boolean;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiAlertRfiStatusEnum {
    RFI_SENT = 'RFI_SENT',
    RFI_RESPONSE_RECEIVED = 'RFI_RESPONSE_RECEIVED'
}


/**
 * Check if a given object implements the InternalApiAlertRfi interface.
 */
export function instanceOfInternalApiAlertRfi(value: object): value is InternalApiAlertRfi {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('alertId' in value) || value['alertId'] === undefined) return false;
    if (!('alertType' in value) || value['alertType'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('templateId' in value) || value['templateId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('counterparties' in value) || value['counterparties'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('isReScreeningEnabled' in value) || value['isReScreeningEnabled'] === undefined) return false;
    return true;
}

export function InternalApiAlertRfiFromJSON(json: any): InternalApiAlertRfi {
    return InternalApiAlertRfiFromJSONTyped(json, false);
}

export function InternalApiAlertRfiFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertRfi {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'alertId': json['alertId'],
        'alertType': InternalApiAlertTypeFromJSON(json['alertType']),
        'conversationId': json['conversationId'],
        'templateId': json['templateId'],
        'title': json['title'],
        'counterpartyName': json['counterpartyName'] == null ? undefined : json['counterpartyName'],
        'counterparties': ((json['counterparties'] as Array<any>).map(BridgeApiConversationCounterpartyFromJSON)),
        'createdTime': (new Date(json['createdTime'])),
        'updatedTime': json['updatedTime'] == null ? undefined : (new Date(json['updatedTime'])),
        'response': json['response'] == null ? undefined : json['response'],
        'requestedFields': json['requestedFields'] == null ? undefined : InternalApiAlertRfiRequestedFieldsFromJSON(json['requestedFields']),
        'status': json['status'],
        'isReScreeningEnabled': json['isReScreeningEnabled'],
    };
}

export function InternalApiAlertRfiToJSON(json: any): InternalApiAlertRfi {
    return InternalApiAlertRfiToJSONTyped(json, false);
}

export function InternalApiAlertRfiToJSONTyped(value?: InternalApiAlertRfi | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'alertId': value['alertId'],
        'alertType': InternalApiAlertTypeToJSON(value['alertType']),
        'conversationId': value['conversationId'],
        'templateId': value['templateId'],
        'title': value['title'],
        'counterpartyName': value['counterpartyName'],
        'counterparties': ((value['counterparties'] as Array<any>).map(BridgeApiConversationCounterpartyToJSON)),
        'createdTime': value['createdTime'].toISOString(),
        'updatedTime': value['updatedTime'] == null ? value['updatedTime'] : value['updatedTime'].toISOString(),
        'response': value['response'],
        'requestedFields': InternalApiAlertRfiRequestedFieldsToJSON(value['requestedFields']),
        'status': value['status'],
        'isReScreeningEnabled': value['isReScreeningEnabled'],
    };
}

